import styled from 'styled-components';
import colors from 'styles/colors';
import fonts from 'styles/fonts';
import media from 'styles/media';
import sizes from 'styles/sizes';

export const HeaderConstrain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  align-items: center;
  top 0;
  max-width: 1220px;
  width: 100%;

  &.compare {
    background: #ffffff;
    margin-bottom: 4px;
    width: 100vw;
    max-width: unset;
    padding: 0 20px;

    &.isSticky {
      background: #ffffff;
      position: fixed;
      box-shadow: 0px 4px 4px rgba(0,0,0,0.15);
    }

    @media (min-width: ${sizes.media.mediumMinWidth}px) {
      background: transparent;
    }
  }
`;

export const Constrain = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 0 ${sizes.gutter.large}px;
	position: relative;
	max-width: ${sizes.constrains.desktop + sizes.gutter.large * 2}px;
	margin: 0 auto;
	transform: none !important;

	${media.medium`
    padding: 0 ${sizes.gutter.small}px;
  `}

	&.compare {
		transform: none !important;
		margin-bottom: 0 !important;

		${HeaderConstrain} {
			padding-top: 20px;
		}
	}
`;

export const ResultsWrapper = styled.div`
	display: block;

	@media (max-width: 810px) {
		display: grid;
		grid-template-columns: 100%;
		margin: 0px;
	}
`;

export const SectionHeader = styled.p`
	font-family: ${fonts.primary.bold};
	font-size: 20px;
	line-height: 24px;
	color: ${colors.functional.black};
	margin-bottom: 12px;
`;

export const ButtonContainer = styled.div`
	width: 290px;
	margin: 10px auto 30px;

	@media (min-width: ${sizes.media.mediumMaxWidth}px) {
		margin: 10px auto 50px;
	}
`;

export const BannerWrapper = styled.div``;

export const BannerPlaceholder = styled.div``;
